window.addEventListener('DOMContentLoaded', function () {
  console.log('Emergency Loaded')
  if(document.querySelector('.expand-emergency')) {
    var item = document.querySelectorAll('.expand-emergency')
    for (var i = 0; i < item.length; i++) {
      item[i].addEventListener('click', function(event) {
        var desc = event.target.parentElement.querySelector('.emergency-description');
        if( desc.classList.contains('show') ) {
          desc.classList.remove('show')
          event.target.innerText = 'Details'
        } else {
          desc.classList.add('show')
          event.target.innerText = 'Less details'
        }
        console.log( event, event.target.parentElement.querySelector('.emergency-description') )
      })
    }
  }
})



// WEBPACK FOOTER //
// ./theme/_base/js/emergency.js